<template>
	<div class="addedtax" :style="{ height: height }">
		<el-row>
			<el-col :span="8">
				<span style="color:transparent">1</span>
			</el-col>
			<el-col :span="2"><span>方案名称：</span></el-col>
			<el-col :span="8">
				<el-input type="text" :disabled="isdisabled" size="mini" v-model="taxscheme.c_name" style="width:230px"></el-input>
			</el-col>
		</el-row>
		<table class="tablecss" cellspacing="0">
			<thead>
				<td class="td0">序号</td>
				<td class="td1">国家</td>
				<td class="td2">增值税</td>
				<td class="td3">操作</td>
			</thead>
			<tbody>
				<tr v-for="(item,index) in taxscheme.addedtax" :key="index">
					<td class="td0">
						{{index+1}}
					</td>
					<td class="td1">
						<el-select
						  v-model="item.cgcountry" size="mini" style="width:99%"
						   multiple
						   filterable
						   placeholder="">
						  <el-option
						    v-for="(it,idx) in countrylist"
						    :key="idx"
						    :label="it.title"
						    :value="it.value+'|'+it.title">
						  </el-option>
						 </el-select>
					</td>
					<td class="td2">
						<el-input type="number" size="mini" v-model="item.tax" style="width:85%"></el-input><span>%</span>
					</td>
					<td class="td3">
						<label>
							<el-link type="primary" :underline="false" @click="addrow(index)">
								添加
							</el-link>
						</label>
						<label style="margin-left:15px">
							<el-link type="danger" :underline="false" @click="delrow(index)">
								删除
							</el-link>
						</label>
					</td>
				</tr>
			</tbody>
		</table>
		<el-row v-if="!btnhidden" class="footerhandler">
			<el-col :span="6" style="color:transparent">
				1
			</el-col>
			<el-col :span="4" class="submitBtn"><div @click="savetaxscheme">保存</div></el-col>
			<el-col :span="4" class="submitBtn_cancel"><div @click="cancel">取消</div></el-col>
		</el-row>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	data() {
		return {
			height: window.innerHeight - 112 + 'px',
			countrylist:[],
			id:'',
			divclass:'addedtax',
			taxscheme:{c_name:'',addedtax:[]},
			addedtaxempty:[{cgcountry:'',tax:''}],
			btnhidden:false,
			isdisabled:false
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/addedtax/addedtax.scss');
		});
	},
	methods: {
		init(param){
			this.id='';
			this.taxscheme={
				c_name:'',
				addedtax:[]
			}
			if(param.id!=undefined){
				this.id=param.id;
			}
			this.getcountry();
		},
		getcountry(){
			var that=this;
			//获取国家基础选项
			this.$apipost.get.GetCountry({ searchkey:'',isall:1 }).then(res => {
				if (res != '') {
					that.countrylist = res.list;
					if(that.id!=''){
						that.isdisabled=true;
						that.gettaxscheme();
					}
					else{
						that.taxscheme.addedtax=JSON.parse(JSON.stringify(that.addedtaxempty));
					}
				}
			});
		},
		addrow(index){
			this.taxscheme.addedtax.push(JSON.parse(JSON.stringify(this.addedtaxempty))[0]);
		},
		delrow(index){
			if(this.taxscheme.addedtax.length>1)
				this.taxscheme.addedtax.splice(index,1);
			else
				this.taxscheme.addedtax=JSON.parse(JSON.stringify(this.addedtaxempty));
		},
		//加载方案内容
		gettaxscheme(){
			var that=this;
			this.$tool.loading('正在加载', this.divclass);
			this.$apipost.get.Gettaxscheme({ c_id:this.id}).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					if(res.state=='1'){
						that.taxscheme=res.info;
					}else{
						this.$tool.message('加载失败',0);
					}
				}
			});
		},
		savetaxscheme(){
			var that=this;
			if(this.taxscheme.c_name=='')
			{
				this.$message.error('请填写方案名称');
				return false;
			}
			if(this.taxscheme.addedtax.length==0){
				this.$message.error('请填写方案明细');
				return false;
			}
			else{
				var index=0,iserror=0;
				this.taxscheme.addedtax.forEach(e=>{
					index++;
					if(e.cgcountry==''){
						this.$message.error('第'+index+'行国家为空');
						iserror=1;
						return false;
					}
					if(e.tax==''){
						this.$message.error('第'+index+'行请填写增值税');
						iserror=1;
						return false;
					}
				});
				if(iserror==1)
					return false;
			}
			this.taxscheme.c_id=this.id;
			this.taxscheme.handleraccount=localStorage.getItem('u_account');
			// console.log('taxscheme',JSON.stringify(this.taxscheme));
			// return false;
			this.btnhidden=true;
			this.$tool.loading('正在保存', this.divclass);
			this.$apipost.post.Savetaxscheme({paraminfo:this.taxscheme}).then(res => {
				that.btnhidden=false;
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message(res.message,1);
					setTimeout(function(){
						that.cancel();
					},1500);
				} else if(res.state=='2'){
					this.$tool.alertmessage(res.message);
				}else {
					this.$tool.message(res.message,0);
				}
			});
		},
		cancel() {
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		}
	}
}
</script>
